<template lang="pug">
  .cancel-final-modal
    .icon-heart-break.text-center.color-mr-purple.xs-f-xxlarge.max-at-tweak
    SectionTitle(text='Cancel Subscription').app-modal-title
    p.color-slate.text-center.xs-f-samll.lg-f-medium.max-at-tweak(data-mr-ass="sorry-text") We're sorry to see you go. If you change your mind, we're here for you and your hair.

    SubmitButtons(
      submit-text='Cancel Subscription'
      :submit-method='submitModal'
      :submit-disabled='savingSub'
      cancel-text='Close'
      :cancel-method='cancelModal'
      :cancel-disabled='savingSub'
    )
  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import SubmitButtons from '../../../SubmitButtons';
  import SectionTitle from "../../../SectionTitle";
  export default {
    name: 'EditAutoDeliveryCancelFinalModal',
    components: {
      SectionTitle,
      SubmitButtons
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit',
        'cancelData'
      ])
    },

    methods: {
      ...mapActions('subscriptions', [
        'cancelSubscription',
        'clearCancelData'
      ]),

      ...mapActions('modal', ['hideModal']),

      submitModal() {
        let { reason, comment } = this.cancelData;
        let payload = {
          sub_id: this.subInEdit.id,
          reason,
          comment
        };

        this.cancelSubscription(payload).then(() => {
          this.$router.push({ name: 'subDashboard' });
          this.hideModal();
          this.clearCancelData();
        });
      },

      cancelModal() {
        this.hideModal();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cancel-final-modal
    p
      padding 1.5em 1em 3em
</style>
